import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
/* Set base url for api */
const API_URL = process.env.REACT_APP_ADMIN_API_URL;
axios.defaults.baseURL = API_URL;

const CancelToken = axios.CancelToken;
let source = CancelToken.source();
// const abortController = new AbortController();
/* Set common header parameters */

axios.defaults.headers.common = {
  "Content-Type": "application/json; charset=utf-8",
  Accept: "application/json; charset=utf-8",
};

/**
 * Set header authorization
 * @param token     Authorization token
 */
export const setHeaderAuthorization = (token:string | null) => {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};

/**
 * Cancel all request
 */
export const cancelAllRequest = (): void => {
  source.cancel();
  setTimeout(() => {
    source = CancelToken.source();
  }, 1500);
};

// export const cancelAllRequest = () => {
//   const signal = abortController.signal;
//   setTimeout(() => {
//     abortController.abort();
//   }, 1500);
// }

/**
 * Handle Axios response
 * @param res   HTTP Response
 * @returns     Return data
 */
export const getResponse =(res: AxiosResponse) => {
  if (res && (res.status === 200 || res.status === 201 || res.status === 204)) {
    if (res.status === 201 || res.status === 204) {
      return true ;
    }
    return res.data;
  }
  throw new Error("Some error occur");
};

/**
 * Get request
 * @param path      API url path
 * @param params    Request parameters
 * @param headers   Request headers
 */
// export const get = (path: string, params?: any, headers?: any) => {
export const get = (path: string, params?: any,headers?: AxiosRequestConfig['headers']) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(path, { params,headers })
        .then(getResponse)
        .then(resolve)
        .catch(reject);
    } catch (error) {
      reject(error);
    }
  });
};

/**
 * Post request
 * @param path      API url path
 * @param params    Request parameters
 * @param headers   Request headers
 */
export const post = (path: string, params?: any, headers?: any) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .post(path, params || {}, { headers })
        .then(getResponse)
        .then(resolve)
        .catch(reject);
    } catch (error) {
      reject(error);
    }
  });
};

/**
 * Put request
 * @param path      API url path
 * @param params    Request parameters
 * @param headers   Request headers
 */
export const put = (path: string, params?: any, headers?: any) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .put(path, params || {}, { headers })
        .then(getResponse)
        .then(resolve)
        .catch(reject);
    } catch (error) {
      reject(error);
    }
  });
};

export const remove = (path: string,params?:any, headers?: any) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .delete(path, { params,headers })
        .then(getResponse)
        .then(resolve)
        .catch(reject);
    } catch (error) {
      reject(error);
    }
  });
};